

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
export default function TermsAndConditions() {
  const [agreed, setAgreed] = useState(false);
 const navigate = useNavigate();
  const handleAccept = () => {
    alert("Terms & Conditions accepted successfully!");

    // After alert OK → redirect to home
    navigate("/");
  };

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        
        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.mainHeading}>Terms & Conditions</h1>
          <div style={styles.headerMeta}>
            <p style={styles.updated}>Last Updated: 20 January 2025</p>
            <div style={styles.documentMeta}>
              <span style={styles.docNumber}>DOC: TNC-MAAMAAS-2025</span>
              <span style={styles.version}>Version: 1.0</span>
            </div>
          </div>
        </div>

        {/* PDF-like Document Container */}
        <div style={styles.documentContainer}>
          <div style={styles.documentContent}>
            
            {/* Warning Box */}
            <div style={styles.warningBox}>
              <div style={styles.warningIcon}>⚠️</div>
              <div style={styles.warningContent}>
                <strong style={styles.warningTitle}>IMPORTANT LEGAL DOCUMENT</strong>
                <p style={styles.warningText}>
                  PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THE MAAMAAS APPLICATION AND SERVICES.
                  BY USING OUR PLATFORM, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS.
                </p>
              </div>
            </div>

            {/* Introduction */}
            <section style={styles.section}>
              <p style={styles.text}>
                This Terms and Conditions Agreement ("<strong>Agreement</strong>") is a legal contract between you 
                ("<strong>User</strong>," "<strong>you</strong>," or "<strong>your</strong>") and 
                Envision Integrated Services Pvt. Ltd. ("<strong>Company</strong>," "<strong>we</strong>," "<strong>us</strong>," or "<strong>our</strong>"), 
                the owner and operator of the Maamaas mobile application and related services (collectively, the "<strong>Platform</strong>").
              </p>
              <p style={styles.text}>
                By downloading, accessing, or using the Platform, you:
              </p>
              <ul style={styles.list}>
                <li style={styles.listItem}>Acknowledge that you have read, understood, and agree to be bound by this Agreement.</li>
                <li style={styles.listItem}>Represent that you are at least 18 years old and legally competent to enter into a contract.</li>
                <li style={styles.listItem}>Consent to our collection, use, and disclosure of your information as outlined in our Privacy Policy.</li>
              </ul>
              <p style={styles.text}>
                If you do not agree to all the terms of this Agreement, you are not permitted to access or use the Platform.
              </p>
            </section>

            {/* SECTION 1 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>1. Definitions</h2>
              <div style={styles.definitionGrid}>
                <div style={styles.definitionItem}>
                  <strong style={styles.term}>Platform:</strong>
                  <span style={styles.definition}>Refers to the Maamaas mobile application, website, and all related services and technologies.</span>
                </div>
                <div style={styles.definitionItem}>
                  <strong style={styles.term}>User:</strong>
                  <span style={styles.definition}>Any individual or entity that accesses or uses the Platform.</span>
                </div>
                <div style={styles.definitionItem}>
                  <strong style={styles.term}>Content:</strong>
                  <span style={styles.definition}>Any data, text, graphics, images, audio, video, reviews, comments, or other materials.</span>
                </div>
                <div style={styles.definitionItem}>
                  <strong style={styles.term}>User Content:</strong>
                  <span style={styles.definition}>Content that you upload, post, or transmit through the Platform.</span>
                </div>
                <div style={styles.definitionItem}>
                  <strong style={styles.term}>Service Provider(s):</strong>
                  <span style={styles.definition}>Third-party businesses or individuals such as restaurants, grocery stores, hotels, travel agencies, caterers, event organizers, drivers, etc.</span>
                </div>
                <div style={styles.definitionItem}>
                  <strong style={styles.term}>Services:</strong>
                  <span style={styles.definition}>The various services offered through the Platform, including but not limited to those detailed in Section 6.</span>
                </div>
              </div>
            </section>

            {/* SECTION 2 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>2. Account Registration and Security</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>Users must be at least 18 years old to create an account.</li>
                  <li style={styles.listItem}>You agree to provide accurate, current, and complete information during registration and keep it updated.</li>
                  <li style={styles.listItem}>You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.</li>
                  <li style={styles.listItem}>You must notify us immediately of any unauthorized access or security breach at support@maamaas.com.</li>
                  <li style={styles.listItem}>You may not create more than one account without authorization.</li>
                  <li style={styles.listItem}>We reserve the right to suspend or delete accounts with false, inaccurate, or incomplete information.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 3 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>3. Description of Services and Our Role</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>The Platform serves as a digital marketplace connecting Users with Service Providers.</li>
                  <li style={styles.listItem}>Maamaas (operated by Envision Integrated Services Pvt. Ltd.) is not the manufacturer, seller, or provider of listed services unless explicitly stated.</li>
                  <li style={styles.listItem}>Listing of Service Providers does not constitute endorsement or guarantee of quality, safety, or legality.</li>
                  <li style={styles.listItem}>We act as an intermediary providing technology for ordering, booking, and payment processing.</li>
                  <li style={styles.listItem}>Any contract for products or services is strictly between the User and the Service Provider.</li>
                  <li style={styles.listItem}>We may introduce new services at any time, governed by this Agreement and any additional service-specific terms.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 4 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>4. User Obligations and Acceptable Use</h2>
              <p style={styles.text}>Users agree not to:</p>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>Violate any applicable local, state, national, or international law.</li>
                  <li style={styles.listItem}>Infringe intellectual property rights of the Company or third parties.</li>
                  <li style={styles.listItem}>Post misleading, harmful, defamatory, abusive, obscene, or objectionable content.</li>
                  <li style={styles.listItem}>Impersonate any individual or entity or misrepresent affiliations.</li>
                  <li style={styles.listItem}>Use automated tools such as bots, scrapers, or data mining tools.</li>
                  <li style={styles.listItem}>Interfere with the Platform's operations, security, or performance.</li>
                  <li style={styles.listItem}>Attempt unauthorized access to accounts, data, or our systems.</li>
                  <li style={styles.listItem}>Reverse engineer, decompile, or disassemble any part of the Platform.</li>
                  <li style={styles.listItem}>Use the Platform for any commercial purposes without our express written consent.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 5 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>5. Orders, Payments, and Financial Terms</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>Prices are determined by Service Providers and may change without notice.</li>
                  <li style={styles.listItem}>Users agree to pay all applicable charges including product/service costs, delivery fees, service fees, taxes, and surcharges.</li>
                  <li style={styles.listItem}>You authorize us and our payment partners to charge your selected payment method.</li>
                  <li style={styles.listItem}>All transactions are in Indian Rupees (INR) unless otherwise specified.</li>
                  <li style={styles.listItem}>Refunds and cancellations follow Service Provider policies and applicable laws.</li>
                  <li style={styles.listItem}>Promotions, discounts, and offers are discretionary and subject to specific terms; may be modified or withdrawn anytime.</li>
                  <li style={styles.listItem}>In case of failed transactions, refunds will be processed within 7-14 business days.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 6 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>6. Service-Specific Terms</h2>
              
              <h3 style={styles.subHeading}>6.1 Food & Beverages</h3>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>Orders authorize Maamaas to place requests with restaurant partners.</li>
                  <li style={styles.listItem}>Deliveries may be handled by restaurant partners or third-party delivery partners.</li>
                  <li style={styles.listItem}>Delivery fees, packaging charges, and surge pricing may apply.</li>
                  <li style={styles.listItem}>Restaurant Partners are solely responsible for food quality, safety, accuracy, and allergen information.</li>
                  <li style={styles.listItem}>Cancellations after restaurant confirmation may incur charges; no refunds for quality disputes without proof.</li>
                  <li style={styles.listItem}>Users must verify order details at delivery and report discrepancies within 30 minutes.</li>
                </ul>
              </div>

              <h3 style={styles.subHeading}>6.2 Future Services</h3>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}><strong>Fresh & Grocery:</strong> Product quality and freshness are Service Provider's responsibility.</li>
                  <li style={styles.listItem}><strong>Catering Services:</strong> Subject to caterer's specific terms; deposits may be required.</li>
                  <li style={styles.listItem}><strong>Travel & Logistics:</strong> Service Providers responsible for service fulfillment; we are not liable for delays or losses.</li>
                  <li style={styles.listItem}><strong>Events & Entertainment:</strong> Tickets subject to event organizer's terms; no refunds unless specified.</li>
                  <li style={styles.listItem}><strong>Hotels & Resorts:</strong> Bookings subject to hotel policies; we are not liable for service quality or safety.</li>
                  <li style={styles.listItem}>Specific terms for each service will be displayed at launch and user's first use constitutes acceptance.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 7 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>7. Intellectual Property</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>All Platform elements including text, graphics, logos, UI, and software belong to Maamaas/Envision Integrated Services Pvt. Ltd. and are protected by copyright and trademark laws.</li>
                  <li style={styles.listItem}>User Content grants us a worldwide, non-exclusive, royalty-free, transferable license to use, display, distribute, and modify for Platform operation.</li>
                  <li style={styles.listItem}>Users represent they own or have necessary rights to all User Content and it doesn't violate third-party rights.</li>
                  <li style={styles.listItem}>Copyright infringement claims should be sent to support@maamaas.com with required details.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 8 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>8. Disclaimer & Limitation of Liability</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>The Platform is provided "as is" and "as available", without warranties of merchantability, fitness for purpose, or non-infringement.</li>
                  <li style={styles.listItem}>We are not liable for acts, omissions, errors, or conduct of Service Providers.</li>
                  <li style={styles.listItem}>Our total aggregate liability is limited to the total amount paid by the User in the 6 months prior to the claim.</li>
                  <li style={styles.listItem}>We are not responsible for indirect, incidental, special, consequential, or punitive damages including lost profits, data, or business opportunities.</li>
                  <li style={styles.listItem}>We don't guarantee uninterrupted, error-free, or completely secure service.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 9 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>9. Indemnification</h2>
              <p style={styles.text}>
                Users agree to indemnify and hold harmless Envision Integrated Services Pvt. Ltd., its directors, officers, employees, and agents from all claims, damages, losses, liabilities, and expenses (including legal fees) arising from:
              </p>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>Your use of the Platform</li>
                  <li style={styles.listItem}>Violation of this Agreement</li>
                  <li style={styles.listItem}>Violation of any third-party rights</li>
                  <li style={styles.listItem}>Your interaction with Service Providers</li>
                  <li style={styles.listItem}>Any content you submit to the Platform</li>
                </ul>
              </div>
            </section>

            {/* SECTION 10 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>10. Termination</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>We may suspend or terminate access at any time without notice for violations of this Agreement.</li>
                  <li style={styles.listItem}>Users may close accounts via account settings or by emailing support@maamaas.com.</li>
                  <li style={styles.listItem}>Upon termination: your license ends, you must stop using the Platform, and certain provisions survive termination.</li>
                  <li style={styles.listItem}>We may permanently delete account data post-termination as per our data retention policy.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 11 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>11. Modification of Agreement</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>We may update this Agreement at any time at our sole discretion.</li>
                  <li style={styles.listItem}>Notice of material changes will be provided via email, in-app notifications, or Platform updates at least 15 days before effective date.</li>
                  <li style={styles.listItem}>Continued use after changes constitutes acceptance. If you disagree with changes, you must stop using the Platform.</li>
                  <li style={styles.listItem}>For new services, first use constitutes acceptance of applicable terms.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 12 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>12. Governing Law & Dispute Resolution</h2>
              <p style={styles.text}>Governed by and construed in accordance with the laws of India.</p>
              <p style={styles.text}>Exclusive jurisdiction lies with courts in Hyderabad, Telangana.</p>
              
              <h3 style={styles.subHeading}>12.1 Arbitration</h3>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>Disputes unresolved through negotiation within 30 days will be referred to arbitration under the Arbitration and Conciliation Act, 1996.</li>
                  <li style={styles.listItem}>The venue and seat shall be Hyderabad, Telangana, and proceedings shall be in English.</li>
                  <li style={styles.listItem}>The arbitral award shall be final and binding on both parties.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 13 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>13. Data Protection & Privacy</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>User data is processed in accordance with applicable laws and our Privacy Policy.</li>
                  <li style={styles.listItem}>By using the Platform, you consent to our data handling practices including collection, storage, processing, and transfer.</li>
                  <li style={styles.listItem}>We implement reasonable security measures but cannot guarantee absolute security.</li>
                  <li style={styles.listItem}>You may access, correct, or delete your personal data through account settings or by contacting us.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 14 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>14. Third-Party Services</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>External websites, payment gateways, logistics providers, or integrated services operate under their own terms.</li>
                  <li style={styles.listItem}>We are not responsible for their content, practices, policies, or services.</li>
                  <li style={styles.listItem}>Interactions with third parties are solely between you and the third party.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 15 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>15. Communications</h2>
              <div style={styles.contentBox}>
                <ul style={styles.list}>
                  <li style={styles.listItem}>By creating an account, you consent to receive transactional, service-related, and promotional communications via email, SMS, calls, or push notifications.</li>
                  <li style={styles.listItem}>You may unsubscribe from promotional messages anytime through account settings or by following opt-out instructions.</li>
                  <li style={styles.listItem}>Service-related communications are mandatory and cannot be opted out of.</li>
                </ul>
              </div>
            </section>

            {/* SECTION 16 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>16. Force Majeure</h2>
              <p style={styles.text}>
                We are not liable for delays or failures due to circumstances beyond reasonable control including natural disasters, war, terrorism, internet outages, strikes, lockdowns, pandemic restrictions, or government actions.
              </p>
            </section>

            {/* SECTION 17 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>17. Severability</h2>
              <p style={styles.text}>
                If any clause is held invalid or unenforceable, it shall be severed and the remaining Agreement remains valid and enforceable.
              </p>
            </section>

            {/* SECTION 18 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>18. No Waiver</h2>
              <p style={styles.text}>
                Failure to enforce any provision will not constitute a waiver of rights or future enforcement.
              </p>
              <p style={styles.text}>
                All waivers must be in writing and signed by authorized Company representatives.
              </p>
            </section>

            {/* SECTION 19 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>19. Entire Agreement</h2>
              <p style={styles.text}>
                This Agreement constitutes the complete and exclusive understanding between you and Maamaas regarding the Platform and supersedes all prior agreements, understandings, and representations.
              </p>
            </section>

            {/* SECTION 20 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>20. Contact Details</h2>
              <div style={styles.contactGrid}>
                <div style={styles.contactItem}>
                  <strong style={styles.contactLabel}>Company Name:</strong>
                  <span style={styles.contactValue}>Envision Integrated Services Pvt. Ltd.</span>
                </div>
                <div style={styles.contactItem}>
                  <strong style={styles.contactLabel}>Brand Name:</strong>
                  <span style={styles.contactValue}>Maamaas</span>
                </div>
                <div style={styles.contactItem}>
                  <strong style={styles.contactLabel}>Registered Address:</strong>
                  <span style={styles.contactValue}>913, Manjeera Trinity Corporate, Kukatpally Housing Board Colony, Kukatpally, Hyderabad, Telangana 500085</span>
                </div>
                <div style={styles.contactItem}>
                  <strong style={styles.contactLabel}>Email:</strong>
                  <span style={styles.contactValue}>info@maamaas.com</span>
                </div>
                <div style={styles.contactItem}>
                  <strong style={styles.contactLabel}>Customer Support:</strong>
                  <span style={styles.contactValue}>Available through in-app chat support and email</span>
                </div>
                <div style={styles.contactItem}>
                  <strong style={styles.contactLabel}>Grievance Officer:</strong>
                  <span style={styles.contactValue}>[Name] can be contacted at [Email] for dispute resolution</span>
                </div>
              </div>
            </section>

            {/* SECTION 21 */}
            <section style={styles.section}>
              <h2 style={styles.heading}>21. Acknowledgement</h2>
              <div style={styles.acknowledgementBox}>
                <p style={styles.acknowledgementText}>
                  BY USING THE MAAMAAS PLATFORM, YOU CONFIRM THAT YOU HAVE READ, UNDERSTOOD, AND AGREED TO THIS AGREEMENT, AND THAT IT APPLIES TO CURRENT AND FUTURE SERVICES. YOU ACKNOWLEDGE THAT WE MAY MODIFY THESE TERMS AND YOUR CONTINUED USE CONSTITUTES ACCEPTANCE OF SUCH CHANGES.
                </p>
              </div>
            </section>

            {/* Acceptance Section */}
            <section style={styles.acceptanceSection}>
              <div style={styles.acceptanceBox}>
                <h3 style={styles.acceptanceTitle}>Acceptance of Terms</h3>
                
                {/* Checkbox */}
                <div style={styles.checkboxRow}>
                  <label style={styles.checkboxLabel}>
                    <input 
                      type="checkbox" 
                      style={styles.checkbox}
                      checked={agreed}
                      onChange={(e) => setAgreed(e.target.checked)}
                    />
                    <span style={styles.checkboxText}>
                      I have read, understood, and agree to be bound by these Terms & Conditions
                    </span>
                  </label>
                </div>

                {/* Signature Upload */}
                <div style={styles.signatureSection}>
                  <p style={styles.signatureLabel}>Digital Signature Acceptance</p>
                  <div style={styles.signatureBox}>
                    <input 
                      type="file" 
                      style={styles.fileInput}
                      accept=".jpg,.jpeg,.png,.pdf"
                    />
                    <div style={styles.fileHint}>
                      Upload your signature (JPG, PNG, or PDF, max 5MB)
                    </div>
                  </div>
                </div>

                {/* Button */}
                {/* <button 
                  style={{
                    ...styles.button,
                    ...(agreed ? styles.buttonActive : styles.buttonDisabled)
                  }}
                  disabled={!agreed}
                >
                  Accept & Continue
                </button> */}


                <button
      style={{
        ...styles.button,
        ...(agreed ? styles.buttonActive : styles.buttonDisabled)
      }}
      disabled={!agreed}
      onClick={agreed ? handleAccept : null}
    >
      Accept & Continue
    </button>

                <p style={styles.legalNote}>
                  By clicking "Accept & Continue", you electronically sign this agreement and agree to be legally bound by these terms.
                </p>
              </div>
            </section>

          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={styles.footerText}>
            © 2025 Envision Integrated Services Pvt. Ltd. All rights reserved.
          </p>
        </div>

      </div>
    </div>
  );
}

/* ENHANCED CSS */
const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    background: "blue",
    marginTop: "60px",  
    padding: "20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#333",
    lineHeight: "1.6",
  },
  wrapper: {
    maxWidth: "1000px",
    margin: "0 auto",
  },
  header: {
    background: "white",
    padding: "30px 40px",
    borderRadius: "12px 12px 0 0",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    marginBottom: "0",
  },
  mainHeading: {
    fontSize: "36px",
    fontWeight: "700",
    color: "#2c3e50",
    marginBottom: "8px",
    borderBottom: "3px solid #e74c3c",
    paddingBottom: "10px",
    display: "inline-block",
  },
  headerMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "15px",
  },
  updated: {
    fontSize: "14px",
    color: "#7f8c8d",
    fontWeight: "500",
    margin: "0",
  },
  documentMeta: {
    display: "flex",
    gap: "20px",
  },
  docNumber: {
    fontSize: "12px",
    color: "#95a5a6",
    background: "#f8f9fa",
    padding: "4px 8px",
    borderRadius: "4px",
  },
  version: {
    fontSize: "12px",
    color: "#95a5a6",
    background: "#f8f9fa",
    padding: "4px 8px",
    borderRadius: "4px",
  },
  documentContainer: {
    background: "white",
    borderRadius: "0 0 12px 12px",
    boxShadow: "0 8px 40px rgba(0,0,0,0.15)",
    overflow: "hidden",
    minHeight: "600px",
    maxHeight: "80vh",
    overflowY: "auto",
    border: "1px solid #e1e8ed",
  },
  documentContent: {
    padding: "40px",
  },
  warningBox: {
    background: "linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)",
    border: "2px solid #ffc107",
    borderRadius: "8px",
    padding: "20px",
    marginBottom: "30px",
    display: "flex",
    alignItems: "flex-start",
    gap: "15px",
  },
  warningIcon: {
    fontSize: "24px",
    flexShrink: "0",
  },
  warningContent: {
    flex: "1",
  },
  warningTitle: {
    color: "#856404",
    fontSize: "16px",
    marginBottom: "8px",
    display: "block",
  },
  warningText: {
    color: "#856404",
    fontSize: "14px",
    margin: "0",
    lineHeight: "1.5",
  },
  section: {
    marginBottom: "35px",
    paddingBottom: "25px",
    borderBottom: "1px solid #ecf0f1",
  },
  heading: {
    fontSize: "22px",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: "16px",
    paddingBottom: "8px",
    borderBottom: "2px solid #3498db",
    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
    padding: "12px 16px",
    borderRadius: "6px",
  },
  subHeading: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#34495e",
    margin: "20px 0 12px 0",
    paddingLeft: "10px",
    borderLeft: "4px solid #3498db",
  },
  text: {
    fontSize: "15px",
    color: "#444",
    marginBottom: "16px",
    textAlign: "justify",
    
  },
  definitionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "12px",
    marginTop: "15px",
  },
  definitionItem: {
    display: "flex",
    gap: "8px",
    padding: "8px 0",
    borderBottom: "1px dotted #ecf0f1",
  },
  term: {
    color: "#2c3e50",
    minWidth: "140px",
    fontSize: "14px",
  },
  definition: {
    color: "#555",
    fontSize: "14px",
    flex: "1",
  },
  contentBox: {
    background: "#f8f9fa",
    border: "1px solid #e9ecef",
    borderRadius: "8px",
    padding: "20px",
    marginTop: "10px",
  },
  list: {
    paddingLeft: "0",
    margin: "0",
  },
  listItem: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "8px",
    paddingLeft: "20px",
    position: "relative",
  },
  contactGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "12px",
    marginTop: "15px",
  },
  contactItem: {
    display: "flex",
    gap: "10px",
    padding: "10px 0",
    borderBottom: "1px solid #f1f2f6",
  },
  contactLabel: {
    color: "#2c3e50",
    minWidth: "150px",
    fontSize: "14px",
  },
  contactValue: {
    color: "#555",
    fontSize: "14px",
    fontWeight: "500",
    flex: "1",
  },
  acknowledgementBox: {
    background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
    border: "2px solid #2196f3",
    borderRadius: "8px",
    padding: "25px",
    marginTop: "15px",
  },
  acknowledgementText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1565c0",
    textAlign: "center",
    margin: "0",
    lineHeight: "1.5",
  },
  acceptanceSection: {
    marginTop: "40px",
    paddingTop: "30px",
    borderTop: "3px double #bdc3c7",
  },
  acceptanceBox: {
    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
    border: "2px solid #3498db",
    borderRadius: "10px",
    padding: "30px",
    textAlign: "center",
  },
  acceptanceTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: "25px",
  },
  checkboxRow: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "25px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    maxWidth: "500px",
  },
  checkbox: {
    width: "20px",
    height: "20px",
    marginRight: "12px",
    accentColor: "#27ae60",
  },
  checkboxText: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#2c3e50",
    textAlign: "left",
  },
  signatureSection: {
    marginBottom: "25px",
  },
  signatureLabel: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#2c3e50",
    marginBottom: "15px",
  },
  signatureBox: {
    border: "2px dashed #bdc3c7",
    borderRadius: "8px",
    padding: "20px",
    background: "white",
  },
  fileInput: {
    width: "100%",
    marginBottom: "8px",
  },
  fileHint: {
    fontSize: "12px",
    color: "#7f8c8d",
    fontStyle: "italic",
  },
  button: {
    marginTop: "15px",
    padding: "15px 50px",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
  },
  buttonActive: {
    background: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
    color: "white",
  },
  buttonDisabled: {
    background: "#bdc3c7",
    color: "#7f8c8d",
    cursor: "not-allowed",
  },
  legalNote: {
    fontSize: "12px",
    color: "#7f8c8d",
    marginTop: "15px",
    fontStyle: "italic",
  },
  footer: {
    textAlign: "center",
    marginTop: "20px",
    padding: "20px",
  },
  footerText: {
    fontSize: "14px",
    color: "white",
    opacity: "0.8",
  },
};